import { render, staticRenderFns } from "./sub-category-unit.vue?vue&type=template&id=34fc9ed8&lang=pug&"
import script from "./sub-category-unit.vue?vue&type=script&lang=js&"
export * from "./sub-category-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports